<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="请输入ID、用户名" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100" />
            <el-table-column label="用户ID" align="center" prop="uuid" show-overflow-tooltip />
            <el-table-column label="用户名" align="center" prop="user_name" />
            <el-table-column label="邮箱" align="center" prop="email" />
            <el-table-column label="订阅时间" align="center" prop="create_time" />
        </template>
    </ListPage>
</template>

<script>
import { list } from "@/api/content/subscribe";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            list,
            // 查询参数
            query: {
                search_keyword: "",
            },
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
    },
};
</script>
